import { IconComponent } from './types';

const NewTabIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 0h1.636v1H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6.364h1V8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Zm3.5 1h2.714L4.393 4.82l.707.708 3.9-3.9V4.5h1V0H5.5v1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default NewTabIcon;
